<template>
  <div>
    <MasterLayout>
      <div
        class="pmp__bg"
        style="
          margin: 0 auto;
          width: 97%;
          margin-top: 100px;
          flex: 0 0 96.5%;
          border-radius: 15px;
        "
        :style="[
          {
            backgroundImage: `linear-gradient(rgb(0, 0, 0, 0.75), rgb(0, 0, 0, 0.75)), url(${backgroundUrl})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          },
        ]"
      >
        <div class="our__branches__banner" style="width: 100%; height: 150px">
          <div class="row align-items-center section__row">
            <div class="col-md-12 text-center section___column_1">
              <h3 class="our__branches__banner__title">
                <img src="@/assets/img/tanks_icon.png" class="mr-3" />
                {{ pump.displayName }} {{ $t("text.pumpDetails.details") }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="add_driver_row">
          <!-- <div class="col-md-12 col-lg-4">
            <div class="drivers_list">
              <div class="product_summary__wrapper">
                <div class="product_header" v-bind:style="{ '--c': pump.color }">
                  <p>
                    <span>
                      <img src="@/assets/img/drop-of-liquid.png" width="25px" class="mr-3" />
                    </span>
                    {{ pump.productName }}
                  </p>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">{{$t('text.pumpDetails.pumpDisplayName')}}</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ pump.displayName }}</h4>
                  </div>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">{{$t('text.pumpDetails.associateTank')}}</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ pump.tankName }}</h4>
                  </div>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">{{$t('text.pumpDetails.pumpCalibration')}}</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ pumpCalibration }}</h4>
                  </div>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">{{$t('text.pumpDetails.manufacturer')}}</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ pump.manufacturer }}</h4>
                  </div>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">{{$t('text.pumpDetails.pumpModel')}}</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ pump.model }}</h4>
                  </div>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">{{$t('text.pumpDetails.pumpStatus')}}</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ pump.status }}</h4>
                  </div>
                </div>
                <div class="clearfix volume_info">
                  <div class="left_div">
                    <h4 class="vol_sold">Pump Throughput</h4>
                  </div>
                  <div class="right_div">
                    <h4 class="litres">{{ throughputRatio }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="">
            <div
              class="driver_form_row"
              style="width: auto; margin-left: 0px; margin-bottom: 20px"
            >
              <h3 class="text-center py-2 edit_pump_details__text">
                {{ $t("text.pumpDetails.title") }}
              </h3>
              <div class="Add_driver_form">
                <div class="row">
                  <!-- <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpName") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.pumpName')"
                            v-model="pump.name"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div> -->

                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpModel") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.pumpModel')"
                            v-model="pump.model"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div>
                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpDisplayName") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pdisplay_name_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="
                              $t('text.pumpDetails.pumpDisplayName')
                            "
                            v-model="pump.displayName"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="pdisplay_name_error_template"
                      style="display: none"
                    ></div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{
                      $t("text.pumpDetails.associatePumpToTank")
                    }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="
                              $t('text.pumpDetails.associatePumpToTank')
                            "
                            v-model="pump.tankName"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div>
                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpReading") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="confirm_pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.pumpReading')"
                            v-model="pump.currentReading"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="confirm_pin_error_template"
                      style="display: none"
                    ></div>
                  </div>
                </div>
                <div class="row mt-3">
                  <!-- <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpCalibration") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="
                              $t('text.pumpDetails.pumpCalibration')
                            "
                            @input="captureFormEvents($event)"
                            v-model="pumpCalibration"
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div> -->
                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpStatus") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="confirm_pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.pumpStatus')"
                            v-model="pump.status"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="confirm_pin_error_template"
                      style="display: none"
                    ></div>
                  </div>
                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.manufacturer") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="confirm_pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.manufacturer')"
                            v-model="pump.manufacturer"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="confirm_pin_error_template"
                      style="display: none"
                    ></div>
                  </div>
                </div>
                <div class="row mt-3">
                  <!-- <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpModel") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.pumpModel')"
                            v-model="pump.model"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div> -->
                  <!-- <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.pumpStatus") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="confirm_pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="$t('text.pumpDetails.pumpStatus')"
                            v-model="pump.status"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      ref="confirm_pin_error_template"
                      style="display: none"
                    ></div>
                  </div> -->
                </div>

                <!-- <div class="row mt-3">
                  <div class="col-md-12 col-lg-6 mt-3">
                    <label>{{ $t("text.pumpDetails.throughput") }}</label>
                    <div class="form_input_section mt-2">
                      <div class="input__div" ref="pin_input_div">
                        <div class="small_placeholder_div_theme_bg">
                          <img
                            src="@/assets/img/lock.png"
                            width="50%"
                            class="input_placeholder_icon"
                          />
                        </div>
                        <div class="input_field_section">
                          <input
                            type="text"
                            :placeholder="
                              $t('text.pumpDetails.throughputPlaceholder')
                            "
                            v-model="throughputRatio"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                    <div ref="pin_error_template" style="display: none"></div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/pumpimage.png";
import configObject from "@/config";
import countryProducts from "@/products";

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
  },
  data() {
    return {
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      pumpId: this.$route.query.id,
      branch: {},
      branchId: null,
      pump: {},
      backgroundUrl,
      throughputRatio: "",
      pumpCalibration: 0,
    };
  },
  created() {
    document.title = "Pump Details:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Pump Details:: ${branch.name} Retail Outlet`;
    });
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {},
  watch: {
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
        if (this.branchId !== null) {
          this.getPumps();
          // this.getPumpThroughput();
          // this.getPumpCalibration();
        }
      }
    },
  },
  mounted() {},
  methods: {
    getPumps() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          const result = response.data.filter(
            (pump) => pump.id == this.$route.params.pumpId
          )[0];

          // console.log(result);
          // console.log(this.$route.params.pumpId);
          if (result.productName !== undefined) {
            if (
              result.productName.toLowerCase() ===
              this.countryProducts.productsLower.product1
            ) {
              result.color = "#d8991c";
            } else if (
              result.productName.toLowerCase() ===
              this.countryProducts.productsLower.product2
            ) {
              result.color = "#0fce29";
            } else if (
              result.productName.toLowerCase() ===
              this.countryProducts.productsLower.product3
            ) {
              result.color = "#00aced";
            } else if (
              result.productName.toLowerCase() ===
              this.countryProducts.productsLower.product4
            ) {
              result.color = "purple";
            }
          } else if (result.displayName !== undefined) {
            if (
              result.displayName
                .toLowerCase()
                .includes(this.countryProducts.productsLower.product1)
            ) {
              result.color = "#d8991c";
            } else if (
              result.displayName
                .toLowerCase()
                .includes(this.countryProducts.productsLower.product2)
            ) {
              result.color = "#0fce29";
            } else if (
              result.displayName
                .toLowerCase()
                .includes(this.countryProducts.productsLower.product3)
            ) {
              result.color = "#00aced";
            } else if (
              result.displayName
                .toLowerCase()
                .includes(this.countryProducts.productsLower.product4)
            ) {
              result.color = "purple";
            }
          }
          this.pump = result;
        })
        .catch((error) => {});
    },
    getPumpThroughput() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pumps/PumpThroughput/${this.$route.params.pumpId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.throughputRatio = `${response.data.pumpThroughput
            .toFixed(2)
            .toString()} / ${response.data.productThroughput
            .toFixed(2)
            .toString()}`;
        })
        .catch((error) => {});
    },
    getPumpCalibration() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pumps/PumpCalibration/${this.$route.params.pumpId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.pumpCalibration = response.data.calibrationRatio
            ? parseFloat(response.data.calibrationRatio).toFixed(2)
            : 0;
        })
        .catch((error) => {});
    },
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
  },
};
</script>
